<template>
    <div class="rounded-lg" style="z-index: 200; min-height: 500px;">
        <block v-if="loading"></block>
        <v-stepper v-model="step" class="white pa-4">
            <v-stepper-header style="flex-wrap: nowrap;">
                <v-stepper-step :complete="step > 1" step="1">
                    Carga de datos
                </v-stepper-step>
                <v-stepper-step :complete="step > 2" step="2">
                    Verificación de datos
                </v-stepper-step>
                <v-stepper-step :complete="step > 3" step="3">
                    Previsualización de datos
                </v-stepper-step>
                <v-stepper-step step="4">
                    Procesamiento de datos
                </v-stepper-step>
            </v-stepper-header>

            <div style="margin-top: 1rem; display: flex; flex-direction: row; justify-content: flex-end;">
                <!-- <v-btn class="btn-save" @click="downloadTemplate" :disabled="loading">
                    <v-icon class="mr-2">mdi-download</v-icon>Descargar plantilla para importar
                </v-btn> -->
                <v-btn class="btnclean" @click="resetAll" :disabled="loading || !dataLoaded">
                    <v-icon class="mr-2">mdi-broom</v-icon>Reiniciar
                </v-btn>
            </div>
            
            <v-stepper-items>
                
                <!-- Step 1: Upload Json -->
                <v-stepper-content step="1">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">                                
                                <v-card-title class="font-weight-bold text-nowrap">Importar gastos desde archivos JSON</v-card-title>
                                <v-card-actions>
                                    <v-row style="margin-top: 1rem;">
                                        <v-col cols="12" md="6" xs="12">
                                            <div style="margin-bottom: 2rem;">
                                                <input
                                                    id="file-input"
                                                    style="display: none;"
                                                    type="file"
                                                    webkitdirectory
                                                    directory
                                                    multiple
                                                    @click="$event.target.value=''"
                                                    @change="handleFolderFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                                                    Elegir directorio completo 
                                                </label>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div style="margin-bottom: 2rem;">    
                                                <input
                                                    id="file-input-individual"
                                                    style="display: none;"
                                                    type="file"
                                                    multiple
                                                    accept=".json"
                                                    @click="$event.target.value=''"
                                                    @change="handleIndividualFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input-individual" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center; ">
                                                    Elegir varios archivos individualmente
                                                </label>
                                            </div>
                                        </v-col>
                                        
                                        <v-col cols="12">
                                            <div v-if="selectedFilesNames.length > 0" style="margin: 1rem 0;">
                                                <h4>Archivos seleccionados:</h4>
                                                <v-data-table 
                                                    :headers="[{text: '', value: 'name'}]" 
                                                    :items="selectedFilesNames"
                                                    :items-per-page="5"
                                                    :footer-props="{
                                                        showFirstLastPage: false,                                         
                                                        'items-per-page-options': [],
                                                        'items-per-page-text':'Items por pagina:',
                                                    }"
                                                    class="file-table"
                                                >
                                                </v-data-table>
                                            </div>
                                            
                                            <!-- Lista de archivos inválidos -->
                                            <div v-if="invalidJsonFiles.length > 0" style="margin: 1rem 0;">
                                                <v-alert type="warning" dense outlined>
                                                    <h4 style="margin-bottom: 10px;">Archivos que no se procesarán ({{ invalidJsonFiles.length }}):</h4>
                                                    <v-simple-table dense>
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">Archivo</th>
                                                                    <th class="text-left">Motivo</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(file, index) in invalidJsonFiles" :key="index">
                                                                    <td>{{ file.fileName }}</td>
                                                                    <td style="color: #e3191e;">{{ file.error }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                    <p style="margin-top: 10px; font-size: 14px;">
                                                        <strong>Nota:</strong> Los archivos válidos se procesarán normalmente.
                                                    </p>
                                                </v-alert>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                                <v-card-actions style="padding: 1rem; justify-content: flex-end;">
                                    <v-btn v-if="!dataLoaded" class="btn-import" @click="duplicatedValidation" :disabled="loading">
                                        <v-icon class="mr-2">mdi-folder-upload</v-icon>Cargar archivos y continuar
                                    </v-btn>
                                    <v-btn v-else class="btncontinue" @click="nextStep" :disabled="loading">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                
                <!-- Step 2: Verifying data -->
                <v-stepper-content step="2">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Datos de los archivos cargados</v-card-title>
                                <v-card-text v-if="errors" style="display: flex; flex-direction: row;">
                                    <v-icon color="red darken-4" style="margin: 10px; font-size: 20px;" >mdi-alert-circle</v-icon>
                                    <p style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        Algunos proveedores no se encuentran registrados, sus productos no serán procesados.
                                    </p>
                                </v-card-text>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-checkbox v-model="selectAll" @click.prevent="switchSelectAll" label="Seleccionar todo"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-checkbox v-model="percentageIvaCheck" label="Solo tomar % IVA"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="4" v-if="percentageIvaCheck">
                                            <v-text-field
                                                v-model="percentageIva"
                                                outlined
                                                dense
                                                label="Porcentaje de IVA"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row v-show="false">
                                        <v-col cols="12" md="4">
                                            <ClasificationRentaAutocomplete v-model="ClasificationRent" />
                                        </v-col>
                                    </v-row>
                                    <CustomCSVPeriod @customCSVPeriod="setCustomCSVPeriod" @year="setCustomCSVPeriodYear" @month="setCustomCSVPeriodMonth" :cleanState="cleanState" @resetCleanState="() => cleanState = false" :submitState="submitCustomCSVPeriodState" />
                                    
                                    <!-- Card de clasificación para anexos -->
                                    <v-card outlined class="mt-4">
                                        <v-card-title class="text-subtitle-1 font-weight-bold">
                                            Clasificación para anexos
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <ClasificationRentaAutocomplete v-model="globalClasificationRent" />
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-select
                                                        v-model="globalSectorProveedores"
                                                        :items="sectorProveedoresList"
                                                        item-text="Valores"
                                                        item-value="Codigo"
                                                        label="Sector Proveedores"
                                                        outlined
                                                        dense
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-select
                                                        v-model="globalTipoIngresoProveedores"
                                                        :items="tipoIngresoProveedoresList"
                                                        item-text="Valores"
                                                        item-value="Codigo"
                                                        label="Tipo Ingreso Proveedores"
                                                        outlined
                                                        dense
                                                        clearable
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12" md="3" class="text-right">
                                                    <v-btn 
                                                        color="primary" 
                                                        @click="assignAllClassifications"
                                                        :disabled="!globalTipoIngresoProveedores && !globalSectorProveedores && !globalClasificationRent"
                                                    >
                                                        <v-icon left>mdi-check-all</v-icon>
                                                        Asignar a todos
                                                    </v-btn>
                                                </v-col>
                                                <v-col>
                                                    <small>Los campos <b>Tipo de Costo / Gasto</b> y <b>Sector</b> son opcionales; si no se seleccionan, se tomarán los valores predeterminados del proveedor.</small>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-card-text>
                                <v-data-table 
                                    :headers="headers" 
                                    :items="data"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.error" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error.message)">mdi-alert-circle</v-icon>
                                        <v-icon v-else style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                    <template v-slot:item.toEntry="{ item }">
                                        <v-checkbox class="check" v-model="item.toEntry" @click.prevent="switchEntryData(item)" :disabled="item.error && item.error.selloRecibidoRequired"></v-checkbox>
                                        <!-- <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon> -->
                                    </template>
                                    <template v-slot:item.TipoIngresoProveedores="{ item }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.TipoIngresoProveedores"
                                            >
                                                <option :value="null">Seleccionar</option>
                                                <option v-for="tipo in tipoIngresoProveedoresList" :value="tipo.Codigo" :key="tipo.Codigo">
                                                    {{ tipo.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.SectorProveedores="{ item }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.SectorProveedores"
                                            >
                                                <option :value="null">Seleccionar</option>
                                                <option v-for="sector in sectorProveedoresList" :value="sector.Codigo" :key="sector.Codigo">
                                                    {{ sector.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.ClasificationRent="{ item }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.ClasificationRent"
                                            >
                                                <option :value="null">Seleccionar</option>
                                                <option v-for="clasificacion in comprasClasificacionRenta" :value="clasificacion.Codigo" :key="clasificacion.Codigo">
                                                    {{ clasificacion.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.delete="{ item }">
                                        <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon>
                                    </template>
                                </v-data-table>
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="nextStep">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- Step 3: Preview Data -->
                <v-stepper-content step="3">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Gastos importados de los archivos seleccionados</v-card-title>

                                <AccountingAssign
                                    v-if="$store.getters['rolesUser/getCustomRole'](179)"
                                    v-model="account.id_account"
                                    :assignAll="true"
                                    @accountChanged="accountChanged"
                                    @assignAllAccounts="assignAllAccounts"
                                >
                                </AccountingAssign>
                                
                                <v-data-table 
                                    :headers="expensesHeaders" 
                                    :items="expensesData"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.accountSearchButton="{ item, index }">
                                        <span class="">
                                            <a @click="chooseAccount( index )">
                                                <v-icon>mdi-magnify</v-icon>
                                            </a>
                                        </span>
                                    </template>
                                    <template v-slot:item.ItemDeclarationType="{ item, index }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.ItemDeclarationType"
                                                @change="e => data[ index ].ItemDeclarationType = e.target.value"
                                            >
                                                <option v-for="tipoItem in tipoItemCompraGasto" :value="tipoItem.Codigo" :key="tipoItem.Codigo">
                                                    {{ tipoItem.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.account_code="{ item, index }">
                                        <span
                                            v-if="!isSelectShowed"
                                            @click="toggleSelect(index)"
                                            >
                                            {{ item.account_code ?? 'Seleccionar cuenta' }}
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                        <span v-else class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.id_account"
                                                @change="(e) => handleChangeAccount(e, index)"
                                                @blur="handleBlurOnSelect"
                                                :ref="`accountListSelect-${index}`"
                                            >
                                                <option v-for="accountItem in accountList" :value="accountItem.id_account" :key="accountItem.id_account">
                                                    {{ accountItem.account_description }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                </v-data-table>
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btnoption" @click="onClickProcess">Procesar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
        
                <!-- Step 4: Process Data -->
                <v-stepper-content step="4">
                    <v-row>
                        <v-col cols="12">
                            <v-card v-if="loading" class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Procesando la información importada</v-card-title>
                                <!-- <v-card-text style="padding: 0 16px;">
                                    <v-progress-linear
                                        v-if="loading"
                                        indeterminate
                                        color="primary"
                                        class="my-4"
                                    ></v-progress-linear>
                                </v-card-text>
                                <div style="height: 50px;"></div> -->
                            </v-card>
                            <v-card v-else class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Estado del procesamiento de datos</v-card-title>

                                <v-card-text v-if="!processError && processed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Se han procesado un total de {{ processed.length }} facturas de gastos importadas desde los archivos seleccionados.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showProcessed=!showProcessed" style="min-width: 100px;">
                                            {{!showProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <!-- <v-btn class="btnoption" @click="exportToExcel('SUCCESS')" style="background-color: #00a178 !important;">
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn> -->
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table 
                                    v-if="showProcessed"
                                    :headers="processHeaders" 
                                    :items="processed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{}">
                                        <v-icon style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="!processError && notProcessed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        No se logro procesar un total de {{ notProcessed.length }} facturas de gastos importadas, debido a la existencia de errores en la información.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showNotProcessed=!showNotProcessed" style="min-width: 100px;">
                                            {{!showNotProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showNotProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <!-- <v-btn class="btnoption" @click="exportToExcel('ERROR')" style="background-color: #00a178 !important;">
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn> -->
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table 
                                    v-if="showNotProcessed"
                                    :headers="processHeaders" 
                                    :items="notProcessed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Productos por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.error?.provider" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error?.message || 'Ha ocurrido un error al insertar el proveedor de esta factura de gastos.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else-if="item.error?.isDuplicated" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error?.message || 'Esta factura de gastos ya se encuentra registrada en la base de datos.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error?.message || 'Ha ocurrido un error al insertar la factura de gastos de este archivo JSON.')">mdi-alert-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="processError" style="display: flex; flex-direction: row;">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Ha ocurrido un error en el procesamiento, vuelva a intentarlo más tarde. 
                                    </h3> 
                                </v-card-text>

                                <v-card-text v-if="!expensesData.length" style="display: flex; flex-direction: row;">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        No existen productos pendiente de procesamiento. 
                                    </h3> 
                                </v-card-text>
                                
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep" :disabled="expensesData.length > 0 || expensesData.length > 0">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="resetAll">Volver al inicio</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                    
            </v-stepper-items>
        </v-stepper>
        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            v-on:secondary_alert="secondaryAlert"
            :properties="alert"
        >
        </alerts>
        <v-dialog v-model="showModal" :width="dialogWidth">
            <v-card>
                <AccountingItemForm
                    :win="win"
                    v-on:sendSelection="accountSelectionHandler"
                    v-on:closeDialog="showModal = false"
                />
            </v-card>
        </v-dialog>
        <GlobalDiscountDistribution
            ref="discountDistribution"
        />
    </div>
</template>
  
<script>
import Alerts from "@/components/Alerts";
import Block from "@/components/Block";
import AccountingAssign from "./AccountingAssign.vue";
import * as XLSX from "xlsx";
import CustomCSVPeriod from "../../../components/Misc/CustomCSVPeriod.vue";
import ClasificationRentaAutocomplete from "../../../components/Misc/ClasificationRentaAutocomplete.vue";
import { mapGetters } from "vuex";
import AccountingItemForm from "./AccountingItemForm.vue";
import GlobalDiscountDistribution from "../../../components/Misc/GlobalDiscountDistribution.vue";
import { findSelloRecibido, parseJsonRelaxedCanonical } from "@/helpers/parseJson";

export default {
    name: "ExpenseManagmentMassiveEntry",
    props: ["win"],
    components: {
        Block,
        Alerts,
        AccountingAssign,
        CustomCSVPeriod,
        ClasificationRentaAutocomplete,
        AccountingItemForm,
        GlobalDiscountDistribution
    },
    data() {
        return {
            step: 1,
            loading: false,
            dataLoaded: false,
            selectAll: true,
            percentageIvaCheck: true,
            percentageIva: 100,
            id_bussiness: null,
            bussiness: null,
            id_branch: null,
            id_user: null,
            providers: [],
            selectedFiles: [],
            selectedFilesNames: [],
            currentJson: null,
            dataFiles: [],
            headerFiles: [],
            data: [],
            invalidJsonFiles: [],  // Archivos JSON que no se pudieron procesar
            headers: [],
            expensesData: [],
            expensesHeaders: [],
            processHeaders: [],

            accountList: [],
            isSelectShowed: false,
            account: {
                id_account: null
            },

            errors: null,
            processError: false,

            processed: [],
            notProcessed: [],
            showNotProcessed: false,
            showProcessed: false,
            duplicateDocuments: [],
           
            invoiceType: [null, "FCF", "CCF", "NC", "FNS", "FEX", "DCL",'ND'],
            paymentMethod: [ "Efectivo", "Cheque", "Transferencia", "Tarjeta de Crédito", "Otro" ],
            invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito", "Anulada"],
            days: ['8 Dias', '15 Dias', '30 Dias', '90 Dias', '120 Dias', '180 Dias'],

            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
                onAccept: null,
            },
            CustomCSVPeriodFlag: false,
            CustomCSVPeriodYear: null,
            CustomCSVPeriodMonth: null,
            ClasificationRent: '2',
            submitCustomCSVPeriodState: false,
            cleanState: false,
            targetIndex: null,
            showModal: false,
            
            // Campos de clasificación para asignar a todos
            globalTipoIngresoProveedores: null,
            globalSectorProveedores: null,
            globalClasificationRent: '2'
        };
    },
    async mounted() {
        this.id_bussiness = JSON.parse(localStorage.getItem("user")).businessid;
        this.business = JSON.parse(localStorage.getItem("user")).business;
        this.id_branch = JSON.parse(localStorage.getItem("user")).branch;
        this.id_user = JSON.parse(localStorage.getItem("user")).id;
        await this.getAllProviders();
        await this.getAllAccounts();
        
        this.headers = [
            {text: '' , value: 'toEntry'},
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'ID Proveedor' , value: 'provider'},
            {text: 'NIT Proveedor' , value: 'nit'},
            {text: 'NRC Proveedor' , value: 'nrc'},
            {text: 'Nombre Proveedor' , value: 'nombre'},
            {text: 'Nombre Comercial Proveedor' , value: 'nombreComercial'},
            
            {text: 'ivaRete1' , value: 'ivaRete1'},
            {text: 'ivaPerci1' , value: 'ivaPerci1'},
            {text: 'totalIva' , value: 'totalIva'},
            {text: 'reteRenta' , value: 'reteRenta'},
            {text: 'descuNoSuj' , value: 'descuNoSuj'},
            {text: 'descuExenta' , value: 'descuExenta'},
            {text: 'descuGravada' , value: 'descuGravada'},
            {text: 'porcentajeDescuento' , value: 'porcentajeDescuento'},
            {text: 'totalDescu' , value: 'totalDescu'},
            {text: 'totalNoSuj' , value: 'totalNoSuj'},
            {text: 'totalExenta' , value: 'totalExenta'},
            {text: 'totalGravada' , value: 'totalGravada'},
            {text: 'totalNoGravado' , value: 'totalNoGravado'},
            {text: 'subTotalVentas' , value: 'subTotalVentas'},

            {text: 'Total Operación' , value: 'montoTotalOperacion'},
            {text: 'Total a Pagar' , value: 'totalPagar'},
            {text: 'Tipo Ingreso' , value: 'TipoIngresoProveedores'},
            {text: 'Sector' , value: 'SectorProveedores'},
            {text: 'Clasificación Renta' , value: 'ClasificationRent'},
            {text: '' , value: 'delete'},
        ];
        this.expensesHeaders = [
            {text: '' , value: 'accountSearchButton'},
            {text: 'Código' , value: 'account_code'},
            {text: 'Cuenta' , value: 'account_name'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número control' , value: 'numeroControl'},
            {text: 'Codigo generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'Proveedor' , value: 'provider'},
            {text: 'Nombre del gasto' , value: 'descripcion'},
            {text: 'Precio' , value: 'precioUni'},
            {text: 'Cantidad' , value: 'cantidad'},
            {text: 'Estado' , value: 'condicionOperacion'},
            {text: 'Gasto declarable como:' , value: 'ItemDeclarationType'},
            {text: 'Descuento' , value: 'montoDescu'},
            {text: 'Total no sujeto' , value: 'ventaNoSuj'},
            {text: 'Total exento' , value: 'ventaExenta'},
            {text: 'Total gravado' , value: 'ventaGravada'},
            {text: 'Total a pagar' , value: 'totalPagar'},
            {text: 'Cuenta Contable' , value: 'account_code'},
        ];

        this.processHeaders = [
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'ID Proveedor' , value: 'provider'},
            {text: 'NIT Proveedor' , value: 'nit'},
            {text: 'NRC Proveedor' , value: 'nrc'},
            {text: 'Nombre Proveedor' , value: 'nombre'},
            {text: 'Nombre Comercial Proveedor' , value: 'nombreComercial'},
            {text: 'Sub Total' , value: 'subTotal'},
            {text: 'Descuento Total' , value: 'totalDescu'},
            {text: 'Total Operación' , value: 'montoTotalOperacion'},
            {text: 'Total a Pagar' , value: 'totalPagar'},
        ];
    },
    watch: {
        /* tableData: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                this.errors = newValue.some((item) => item.error);
            }
        }, */
        selectedFiles: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    this.selectedFilesNames.push({name: item.name});
                }
            }
        },
        data: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    if(item.toEntry == false) {
                        this.selectAll = false;
                    }
                }
            }
        },
        
    },
    computed: {
        ...mapGetters(["getCatalogMH"]),
        dialogWidth() {
            return this.$vuetify.breakpoint.smAndDown ? "95%" : "60%";
        },
        tipoItemCompraGasto() {
            return this.getCatalogMH("TipoItemCompraGasto");
        },
        tipoIngresoProveedoresList() {
            return this.getCatalogMH("TipoIngresoProveedores");
        },
        sectorProveedoresList() {
            return this.getCatalogMH("SectorProveedores");
        },
        comprasClasificacionRenta() {
            return this.getCatalogMH("ComprasClasificacionRenta");
        },
    },
    methods: {
        chooseAccount(index) {
            this.showModal =true
            this.targetIndex = index;
        },
        accountSelectionHandler(data) {
            this.showModal = false;
            const { id_account, account_code, account_description } = data;

            this.$set(this.expensesData[ this.targetIndex ], 'id_account', id_account);
            this.$set(this.expensesData[ this.targetIndex ], 'account_code', account_code);
            this.$set(this.expensesData[ this.targetIndex ], 'account_name', account_description);
            this.data[ this.targetIndex ].id_account = id_account;
            this.data[ this.targetIndex ].account_code = account_code;
            this.data[ this.targetIndex ].account_name = account_description;
        },
        accountChanged( e ) {
            this.account.id_account = e
        },
        setCustomCSVPeriod(val){
            this.CustomCSVPeriodFlag = val
        },
        setCustomCSVPeriodYear(val){
            this.CustomCSVPeriodYear = val
        },
        setCustomCSVPeriodMonth(val){
            this.CustomCSVPeriodMonth = val
        },
        async nextStep() {
            if(this.step === 1) {
                if(this.selectedFiles.length && !this.dataLoaded) {
                    this.showAlert("warning", "Advertencia", "Antes de continuar debe cargar los archivos seleccionados.");
                    return;
                }
            }
            if(this.step == 2) {
                let errors = 0;

                if( this.CustomCSVPeriodFlag ) {
                    this.submitCustomCSVPeriodState = true;
                    !this.CustomCSVPeriodMonth && ( errors += 1 );
                    !this.CustomCSVPeriodYear && ( errors += 1 );
                }

                if (errors > 0) {
                    this.showAlert(
                        "warning",
                        "Advertencia",
                        "Debe llenar todos los campos obligatorios"
                    );
                    return;
                }

                this.handleExpensesDetails();
            }
            this.step++;
        },
        prevStep() {
            this.step--;
        },
        async getAllProviders() {
            await this.$API.accountingexpenses.getAllProvidersExpenses()
                .then((res) => {
                    this.providers = res.data;
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        handleFolderFiles(event) {
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.endsWith('.json'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON en el directorio seleccionado.');
            }
        },
        handleIndividualFiles(event) {
            //console.log('----here----', event);
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.endsWith('.json') || file.name.endsWith('.JSON'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...this.selectedFiles, ...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON seleccionados.');
            }
        },
        async handleFilesUpload() {
            if (!this.selectedFiles.length) {
                this.showAlert("warning", "Advertencia", "Debe seleccionar los archivos a cargar.");
                return;
            }
            this.loading = true;
            try {
                const duplicatedCodes = new Set(
                    (this.duplicateDocuments || [])
                        .map(item => this.normalizeGenerationCode(item?.codigoGeneracion))
                        .filter(Boolean)
                );
                for (const item of this.dataFiles) {
                    this.currentJson = item.identificacion.codigoGeneracion;                    
                    item.toEntry = true;
                    
                    // Detectar si es la nueva versión
                    const isNewVersion = this.isNewVersionJson(item);
                    
                    const provider = this.checkProvider(item.emisor);
                    if(!provider){
                        //console.log('Not checked');
                        // Para nueva versión, usar datos de cuerpoDocumento.ivaPercibido en lugar de resumen.ivaPerci1
                        const ivaPerci1Value = isNewVersion ? item.cuerpoDocumento.ivaPercibido : item.resumen?.ivaPerci1;
                        const newProvider = await this.addProvider({ ...item.emisor , ivaPerci1: ivaPerci1Value });
                        if(newProvider && newProvider.ID_Provider) {
                            item.provider = newProvider.ID_Provider;
                            item.id_account = newProvider.id_purchases_account ? newProvider.id_purchases_account : null;
                            //this.providers = await this.getAllProviders();
                        }
                        else {
                            item.error = {
                                providerError: true,
                                message: 'No se pudo insertar el proveedor de esta factura, intentelo nuevamente más tarde.',
                            };
                            item.toEntry = false;
                        }
                    }
                    else {
                        //console.log('Provider checked', provider);
                        item.provider = provider.ID_Provider;
                        item.id_account = provider.id_purchases_account ? provider.id_purchases_account : null;
                        item.account_code = provider.id_purchases_account ? this.accountList.find(i => i.id_account == provider.id_purchases_account)?.account_code : null;
                        item.account_description = provider.id_purchases_account ? this.accountList.find(i => i.id_account == provider.id_purchases_account)?.account_description : null;
                    }

                    
                    const normalizedCode = this.normalizeGenerationCode(item.identificacion?.codigoGeneracion);
                    const duplicateDocument = this.getDuplicateDocumentByCode(normalizedCode);
                    const isPurchaseDuplicate = duplicateDocument?.source === 'purchase';
                    if(duplicatedCodes.has(normalizedCode)) {
                        item.error = {
                            ...(item.error || {}),
                            isDuplicated: !isPurchaseDuplicate,
                            purchaseDuplicate: isPurchaseDuplicate,
                            message: item.error?.message ? item.error?.message : (isPurchaseDuplicate ? 'Esta factura ya se encuentra registrada como compra de inventario.' : 'Esta factura ya se encuentra registrada, si desea sobreescribir la información existente debera seleccionar el checkbox.')
                        };
                    }

                    if(item.identificacion.tipoDte == "03") item.invoiceType = "CCF";
                    if(item.identificacion.tipoDte == "05") item.invoiceType = "NC";
                    if(item.identificacion.tipoDte == "06") item.invoiceType = "ND";
                    if(item.identificacion.tipoDte == "11") item.invoiceType = "FEX";
                    if(item.identificacion.tipoDte == "14") item.invoiceType = "FNS";
                    //if(item.identificacion.tipoDte == "15") item.invoiceType = "CDD";
                    if(item.identificacion.tipoDte == "01") item.invoiceType = "FCF";
                    if(item.identificacion.tipoDte == "09") item.invoiceType = "DCL";

                    let tributos = {
                        iva: 0,
                    };

                    // Detectar si es la nueva versión
                    const isNewVersionFormat = this.isNewVersionJson(item);

                    if (!isNewVersionFormat && item.resumen && item.resumen.tributos && item.resumen.tributos.length) {
                        // Versión original - procesar tributos desde resumen
                        let index = 11;
                        for (const el of item.resumen.tributos) {
                            if(el.codigo == '20' || el.descripcion.includes('IVA')){
                                tributos.iva = el.valor;
                                if((this.headers.some(i => i.value == 'iva')) !== true) {
                                    this.headers.splice(index, 0, {text: 'IVA' , value: 'iva'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'D1' || el.descripcion.includes('FOVIAL')){
                                tributos.fovial = el.valor;
                                if((this.headers.some(i => i.value == 'fovial')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Fovial' , value: 'fovial'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'C8' || el.descripcion.includes('COTRANS')){
                                tributos.cotrans = el.valor;
                                if((this.headers.some(i => i.value == 'cotrans')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Cotrans' , value: 'cotrans'});
                                    index += 1;
                                }
                            }
                            else {
                                tributos[el.descripcion] = el.valor;
                                if((this.headers.some(i => i.value == el.descripcion)) !== true) {
                                    this.headers.splice(index, 0, {text: el.descripcion , value: el.descripcion});
                                    index += 1;
                                }
                            }
                        }
                    } else if (isNewVersionFormat && item.cuerpoDocumento) {
                        // Nueva versión - extraer IVA desde cuerpoDocumento
                        tributos.iva = item.cuerpoDocumento.iva || 0;
                        if(tributos.iva > 0 && (this.headers.some(i => i.value == 'iva')) !== true) {
                            this.headers.splice(11, 0, {text: 'IVA' , value: 'iva'});
                        }
                    }

                    if(item.invoiceType == "FEX" && !isNewVersionFormat && item.resumen) {
                        item.flete = item.resumen.flete;       
                        item.seguro = item.resumen.seguro;       
                    }

                    let rowData;
                    
                    if (isNewVersionFormat) {
                        // Nueva versión - usar datos de cuerpoDocumento
                        rowData = {
                            ...item,
                            ivaRete1: 0, // No esta en la version nueva creada para mantener el formato original
                            ivaPerci1: item.cuerpoDocumento.ivaPercibido || 0,
                            totalIva: item.cuerpoDocumento.iva || 0,
                            reteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            descuExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuGravada: 0, // No esta en la version nueva creada para mantener el formato original
                            porcentajeDescuento: 0, // No esta en la version nueva creada para mantener el formato original
                            totalDescu: 0, // No esta en la version nueva creada para mantener el formato original
                            totalNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            totalExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            totalGravada: item.cuerpoDocumento.valorOperaciones || 0,
                            totalNoGravado: 0, // No esta en la version nueva creada para mantener el formato original
                            subTotalVentas: item.cuerpoDocumento.subTotal || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            nit: item.emisor.nit,
                            nrc: item.emisor.nrc,
                            nombre: item.emisor.nombre,
                            nombreComercial: item.emisor.nombreComercial,
                            subTotal: item.cuerpoDocumento.subTotal || 0,
                            montoTotalOperacion: item.cuerpoDocumento.valorOperaciones || 0,
                            totalPagar: item.cuerpoDocumento.liquidoApagar || 0,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            ItemDeclarationType: 2,
                            // Campos específicos de la nueva versión
                            comision: item.cuerpoDocumento.comision || 0,
                            ivaComision: item.cuerpoDocumento.ivaComision || 0,
                            montoSujetoPercepcion: item.cuerpoDocumento.montoSujetoPercepcion || 0,
                            montoSinPercepcion: item.cuerpoDocumento.montoSinPercepcion || 0,
                            empleadoEntrega: item.extension ? item.extension.nombEntrega : null,
                            codigoEmpleado: item.extension ? item.extension.codEmpleado : null,
                            selloRecibido: findSelloRecibido(item),
                            // Campos de clasificación para anexos
                            TipoIngresoProveedores: null,
                            SectorProveedores: null,
                            ClasificationRent: '2'
                        };
                    } else {
                        // Versión original
                        const totalPagar = item.resumen?.totalPagar || item.resumen?.montoTotalOperacion || 0;
                        rowData = {
                            ...item,
                            ivaRete1: item.resumen?.ivaRete1 || 0,
                            ivaPerci1: item.resumen?.ivaPerci1 || 0,
                            totalIva: item.resumen?.totalIva || 0,
                            reteRenta: item.resumen?.reteRenta || 0,
                            descuNoSuj: item.resumen?.descuNoSuj || 0,
                            descuExenta: item.resumen?.descuExenta || 0,
                            descuGravada: item.resumen?.descuGravada || 0,
                            porcentajeDescuento: item.resumen?.porcentajeDescuento || 0,
                            totalDescu: item.resumen?.totalDescu || 0,
                            totalNoSuj: item.resumen?.totalNoSuj || 0,
                            totalExenta: item.resumen?.totalExenta || 0,
                            totalGravada: item.resumen?.totalGravada || 0,
                            totalNoGravado: item.resumen?.totalNoGravado || 0,
                            subTotalVentas: item.resumen?.subTotalVentas || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            nit: item.emisor.nit,
                            nrc: item.emisor.nrc,
                            nombre: item.emisor.nombre,
                            nombreComercial: item.emisor.nombreComercial,
                            subTotal: item.resumen?.subTotal || 0,
                            montoTotalOperacion: item.resumen?.montoTotalOperacion || 0,
                            totalPagar: totalPagar,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            ItemDeclarationType: 2,
                            selloRecibido: findSelloRecibido(item),
                            // Campos de clasificación para anexos
                            TipoIngresoProveedores: null,
                            SectorProveedores: null,
                            ClasificationRent: '2'
                        };
                    }
                    
                    for (const prop in tributos) {
                        rowData = {
                            ...rowData,
                            [prop]: tributos[prop]
                        }
                    }
                    
                    // Validación de selloRecibido: Si ivaPerci1 > 0, selloRecibido es requerido
                    const ivaPerci1Value = rowData.ivaPerci1 || 0;
                    const selloRecibidoValue = rowData.selloRecibido;
                    
                    if (ivaPerci1Value > 0 && (!selloRecibidoValue || selloRecibidoValue.trim() === '')) {
                        // Si hay percepción de IVA pero no hay sello recibido, marcar como error
                        rowData.error = {
                            selloRecibidoRequired: true,
                            message: rowData.error?.message 
                                ? `${rowData.error.message} Además, el sello recibido es requerido cuando hay percepción de IVA.`
                                : 'El sello recibido es requerido para facturas con percepción de IVA (1%).'
                        };
                        rowData.toEntry = false;
                    }
                    
                    this.data.push(rowData);
                }
                setTimeout(() => {
                    this.loading = false;
                    this.dataLoaded = true;
                    this.currentJson = null; 
                    //console.log(this.data);
                    
                    // Mostrar alerta informativa si hay archivos inválidos
                    if (this.invalidJsonFiles.length > 0) {
                        this.showAlert("warning", "Archivos procesados con advertencias", 
                            `Se cargaron ${this.data.length} archivo(s) válido(s) correctamente.\n\n` +
                            `${this.invalidJsonFiles.length} archivo(s) no pudieron procesarse debido a errores de formato o estructura.\n\n` +
                            `Puede revisar los archivos inválidos en la tabla superior y presionar "Continuar" cuando esté listo.`);
                    } else {
                        this.showAlert("success", "Exito", "Los archivos seleccionados fueron cargados correctamente.");
                    }
                }, 1000);
            } 
            catch (error) {                
                console.log(this.selectedFilesNames);
                
                const fileName = this.selectedFilesNames.find(item => item.name.includes(this.currentJson));
                console.log(error.message);
                this.loading = false;
                if(fileName && fileName.name) {
                    this.showAlert("warning", "Advertencia", `Ha ocurrido un error al cargar el archivo ${fileName.name}, revise la estructura del JSON.`);
                }
                else {
                    this.showAlert("warning", "Advertencia", "Ha ocurrido un error al cargar los archivos, vuelva a intentarlo más tarde.");
                }
                this.currentJson = null; 
            }
        },
        async duplicatedValidation() {
            this.loading = true;
            this.invalidJsonFiles = [];  // Limpiar lista de inválidos
            let formatErrorFiles = []
            // Procesar los archivos JSON seleccionados
            for (const file of this.selectedFiles) {
                if (file.type === "application/json") {
                    try {
                        const content = await this.readFile(file);
                        const jsonContent = parseJsonRelaxedCanonical(content);
                        const currentCode = this.normalizeGenerationCode(jsonContent?.identificacion?.codigoGeneracion);
                        const isInDataFiles = currentCode
                            ? this.dataFiles.some(item => this.normalizeGenerationCode(item?.identificacion?.codigoGeneracion) === currentCode)
                            : false;
                        jsonContent['fileName'] = file.name;
                        if (!isInDataFiles) {
                            this.dataFiles.push(jsonContent);
                        }
                        // Los duplicados se omiten automáticamente
                    } catch (error) {
                        console.error(`Error parsing JSON file ${file.name}:`, error);
                        formatErrorFiles.push({
                            fileName: file.name,
                            error: `Error de formato JSON: ${error.message}`
                        });
                    }
                }
            }
            
            // Guardar archivos con error de formato
            this.invalidJsonFiles.push(...formatErrorFiles);
            
            // Manejar archivos JSON inválidos
            if (formatErrorFiles.length > 0 && this.dataFiles.length === 0) {
                // Si todos los archivos son inválidos, mostrar error y detener
                const errorDetails = formatErrorFiles.map(item => `${item.fileName}: ${item.error}`).join('\n');
                this.showAlert("warning", "Error de formato JSON", 
                    `Todos los archivos tienen errores de formato JSON y no pueden ser procesados:\n\n${errorDetails}\n\nPor favor, corrija estos archivos antes de continuar.`);
                this.loading = false;
                return;
            }
            
            // Si hay archivos válidos, continuar con la validación de estructura (sin mostrar alerta aún)
            this.structureValidation();

        },
        structureValidation() {
            console.log('structureValidation');
            
            // Validar estructura de archivos
            const structureInvalidFiles = this.dataFiles.filter(file => !this.jsonValidation(file));
            this.dataFiles = this.dataFiles.filter(file => this.jsonValidation(file));
            
            // Agregar archivos con estructura inválida a la lista
            structureInvalidFiles.forEach(file => {
                this.invalidJsonFiles.push({
                    fileName: file.fileName,
                    error: 'Estructura JSON inválida (faltan campos requeridos)'
                });
            });
            
            // Si no hay archivos válidos, mostrar error y detener
            if (this.dataFiles.length === 0) {
                this.showAlert("warning", "Advertencia", "Ninguno de los archivos tiene la estructura correcta. Por favor, revise los archivos y corríjalos antes de continuar.");
                this.loading = false;
                return;
            }
            
            // Continuar con la validación de códigos de generación duplicados
            this.validateStoredGenerationCodes();
        },
        jsonValidation(json) {
            if (!json) return false;

            // Detectar si es la nueva versión del JSON (DCL - Declaración de Comisiones por Liquidación)
            const isNewVersion = this.isNewVersionJson(json);

            if (isNewVersion) {
                // Validación para la nueva versión
                const newVersionAttributes = [
                    'emisor',
                    'receptor', 
                    'identificacion',
                    'cuerpoDocumento',
                    'extension'
                    // responseMH es opcional en la nueva versión
                ];

                for (const key of newVersionAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal para nueva versión: ${key}`);
                        return false;
                    }
                }
            } else {
                // Validación para la versión original
                const principalAttributes = [
                    'emisor',
                    //'donante',
                    'receptor',
                    'resumen',
                    'identificacion',
                    'cuerpoDocumento'
                ];

                for (const key of principalAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal: ${key}`);
                        return false;
                    }
                }
            }

            return true;
        },
        isNewVersionJson(json) {
            // Detecta si es la nueva versión basándose en:
            // 1. Presencia de 'extension' 
            // 2. tipoDte "09" (DCL)
            // 3. cuerpoDocumento como objeto (no array)
            return json.extension && 
                   json.identificacion?.tipoDte === "09" && 
                   json.cuerpoDocumento && 
                   !Array.isArray(json.cuerpoDocumento);
        },
        normalizeGenerationCode(value) {
            if (value === null || value === undefined) {
                return null;
            }

            const normalized = String(value).trim().replace(/[\s-]+/g, "");
            return normalized.length > 0 ? normalized : null;
        },
        groupDuplicateDocuments(duplicates) {
            const grouped = new Map();

            duplicates.forEach((duplicate) => {
                const code = this.normalizeGenerationCode(duplicate?.codigoGeneracion);
                if (!code) {
                    return;
                }

                if (!grouped.has(code)) {
                    grouped.set(code, new Set());
                }

                const sourceLabel = duplicate?.sourceLabel
                    || (duplicate?.source === 'purchase' ? 'Compras de inventario' : 'Gastos');
                grouped.get(code).add(sourceLabel);
            });

            return Array.from(grouped.entries()).map(([codigoGeneracion, labels]) => ({
                codigoGeneracion,
                sourceLabels: Array.from(labels),
            }));
        },
        buildDuplicateBody(duplicates) {
            const duplicateLines = this.groupDuplicateDocuments(duplicates)
                .map(({ codigoGeneracion, sourceLabels }) => `El documento ${codigoGeneracion} ya fue agregado en ${sourceLabels.join(' y ')}.`);
            
            duplicateLines.push('¿Desea continuar de todas formas?');
            return duplicateLines.join('<br>');
        },
        getDuplicateDocumentByCode(code) {
            const normalizedCode = this.normalizeGenerationCode(code);
            return (this.duplicateDocuments || []).find(
                (duplicate) => this.normalizeGenerationCode(duplicate?.codigoGeneracion) === normalizedCode
            ) || null;
        },
        async validateStoredGenerationCodes() {
            const generationCodes = [...new Set(
                this.dataFiles
                    .map(item => this.normalizeGenerationCode(item?.identificacion?.codigoGeneracion))
                    .filter(Boolean)
            )];

            this.duplicateDocuments = [];

            if (generationCodes.length === 0) {
                this.handleFilesUpload();
                return;
            }

            try {
                const response = await this.$API.accountingexpensesentry.verifyGenerationCodes({
                    codigosGeneracion: generationCodes
                });

                const duplicates = Array.isArray(response?.duplicates) ? response.duplicates : [];
                this.duplicateDocuments = duplicates;

                if (duplicates.length > 0) {
                    this.loading = false;
                    this.showAlert(
                        "question3",
                        "Advertencia",
                        `Uno o más documentos ya fueron agregados al sistema.<br><br>${this.buildDuplicateBody(duplicates)}`,
                        "duplicateDocuments"
                    );
                    return;
                }

                this.handleFilesUpload();
            } catch (error) {
                console.error(error);
                this.loading = false;
                this.showAlert(
                    "warning",
                    "Advertencia",
                    "No fue posible validar si los documentos ya existen en el sistema."
                );
            }
        },
        async handleExpensesDetails() {
            this.loading = true;
            const expenses = [];
            for (const item of this.dataFiles) {                                                
                if(item.toEntry === true && !item.error?.providerError) {
                    let processedDocument;
                    try {
                        processedDocument = await this.$refs.discountDistribution.processDocument(item);
                        this.$set(item, 'processedDocument', processedDocument);
                    } catch (error) {
                        this.showAlert('warning', 'Descuento pendiente', error.message);
                        this.loading = false;
                        return;
                    }
                    
                    // Detectar si es la nueva versión
                    const isNewVersion = this.isNewVersionJson(item);
                    
                    if (isNewVersion) {
                        // Nueva versión - cuerpoDocumento es un objeto
                        // Extraer numeroDocumento de documentoRelacionado si existe
                        let numeroDocumentoRelacionado = null;
                        if (item.documentoRelacionado && 
                            Array.isArray(item.documentoRelacionado) && 
                            item.documentoRelacionado.length > 0) {
                            numeroDocumentoRelacionado = item.documentoRelacionado[0].numeroDocumento || null;
                        }
                        
                        const headerExpense = {
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            documentType: 2,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            subTotal: item.cuerpoDocumento.subTotal || 0,
                            montoTotalOperacion: item.cuerpoDocumento.valorOperaciones || 0,
                            totalPagar: item.cuerpoDocumento.liquidoApagar || 0,
                            totalLetras: item.cuerpoDocumento.totalLetras || '',
                            ivaPerci1: item.cuerpoDocumento.ivaPercibido || 0,
                            ivaRete1: 0, // No esta en la version nueva creada para mantener el formato original
                            reteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                            condicionOperacion: 'Cancelada', // Valor por defecto para nueva versión
                            id_account: item.id_account,
                            account_code: item.account_code,
                            account_name: item.account_description,
                            NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                        };
                        
                        // Para la nueva versión, crear un solo gasto con toda la información
                        const expense = {
                            ...headerExpense,
                            descripcion: `${item.emisor.nombre}`,
                            precioUni: item.cuerpoDocumento.liquidoApagar || 0,
                            cantidad: 1,
                            montoDescu: 0,
                            ventaNoSuj: 0,
                            ventaExenta: 0,
                            ventaGravada: item.cuerpoDocumento.valorOperaciones || 0,
                            total: item.cuerpoDocumento.liquidoApagar || 0,
                            ItemDeclarationType: 2,
                            // Campos específicos de la nueva versión
                            comision: item.cuerpoDocumento.comision || 0,
                            ivaComision: item.cuerpoDocumento.ivaComision || 0,
                            montoSujetoPercepcion: item.cuerpoDocumento.montoSujetoPercepcion || 0,
                            montoSinPercepcion: item.cuerpoDocumento.montoSinPercepcion || 0,
                            empleadoEntrega: item.extension ? item.extension.nombEntrega : null,
                            codigoEmpleado: item.extension ? item.extension.codEmpleado : null,
                            selloRecibido: findSelloRecibido(item),
                            // Campos de clasificación para anexos
                            TipoIngresoProveedores: item.TipoIngresoProveedores || null,
                            SectorProveedores: item.SectorProveedores || null,
                            ClasificationRent: item.ClasificationRent || '2'
                        };

                        expenses.push(expense);
                        
                    } else {
                        // Versión original - cuerpoDocumento es un array
                        // Extraer numeroDocumento de documentoRelacionado si existe
                        let numeroDocumentoRelacionado = null;
                        if (item.documentoRelacionado && 
                            Array.isArray(item.documentoRelacionado) && 
                            item.documentoRelacionado.length > 0) {
                            numeroDocumentoRelacionado = item.documentoRelacionado[0].numeroDocumento || null;
                        }
                        
                        const totalPagar = item.resumen?.totalPagar || item.resumen?.montoTotalOperacion || 0;
                        const headerExpense = {
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            documentType: 2,
                            invoiceType: item.invoiceType,
                            provider: item.provider,
                            subTotal: item.resumen?.subTotal || 0,
                            montoTotalOperacion: item.resumen?.montoTotalOperacion || 0,
                            totalPagar: totalPagar,
                            totalLetras: item.resumen?.totalLetras || '',
                            ivaPerci1: item.resumen?.ivaPerci1 || 0,
                            ivaRete1: item.resumen?.ivaRete1 || 0,
                            reteRenta: item.resumen?.reteRenta || 0,
                            condicionOperacion: this.invoiceStatus[item.resumen?.condicionOperacion] || 'Pendiente de pago',
                            id_account: item.id_account,
                            account_code: item.account_code,
                            account_name: item.account_description,
                            NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                        };
                        
                        // Procesar cada elemento del cuerpoDocumento
                        const processingDetails = processedDocument.details;
                        for (const element of processingDetails) {
                            // Detectar si el item tiene hidrocarburos
                            let fovialItem = 0;
                            let cotransItem = 0;
                            let isHidrocarburo = false;

                            if (element.tributos && Array.isArray(element.tributos)) {
                                const hasFovial = element.tributos.includes('D1');
                                const hasCotrans = element.tributos.includes('C8');
                                
                                if (hasFovial || hasCotrans) {
                                    isHidrocarburo = true;
                                    if (hasFovial) {
                                        fovialItem = parseFloat((element.cantidad * 0.20).toFixed(2));
                                    }
                                    if (hasCotrans) {
                                        cotransItem = parseFloat((element.cantidad * 0.10).toFixed(2));
                                    }

                                    // Agregar columnas de FOVIAL y COTRANS si no existen
                                    if (!this.expensesHeaders.some(h => h.value === 'fovial')) {
                                        const totalPagarIndex = this.expensesHeaders.findIndex(h => h.value === 'totalPagar');
                                        this.expensesHeaders.splice(totalPagarIndex, 0, {text: 'Fovial', value: 'fovial'});
                                    }
                                    if (!this.expensesHeaders.some(h => h.value === 'cotrans')) {
                                        const totalPagarIndex = this.expensesHeaders.findIndex(h => h.value === 'totalPagar');
                                        this.expensesHeaders.splice(totalPagarIndex, 0, {text: 'Cotrans', value: 'cotrans'});
                                    }
                                }
                            }

                            const expense = {
                                ...headerExpense,
                                descripcion: element.descripcion,
                                precioUni: element.precioUni,
                                cantidad: element.cantidad,
                                montoDescu: element.montoDescu,
                                ventaNoSuj: element.ventaNoSuj,
                                ventaExenta: element.ventaExenta,
                                ventaGravada: element.ventaGravada,
                                ItemDeclarationType: 2,
                                fovial: fovialItem,
                                cotrans: cotransItem,
                                isHidrocarburo: isHidrocarburo,
                                // Campos de clasificación para anexos
                                TipoIngresoProveedores: item.TipoIngresoProveedores || null,
                                SectorProveedores: item.SectorProveedores || null,
                                ClasificationRent: item.ClasificationRent || '2'
                            };
                            
                            if(expense.ventaNoSuj != 0 && expense.ventaExenta == 0 && expense.ventaGravada == 0) expense.total = expense.ventaNoSuj;
                            else if(expense.ventaNoSuj == 0 && expense.ventaExenta != 0 && expense.ventaGravada == 0) expense.total = expense.ventaExenta;
                            else expense.total = expense.ventaGravada;

                            expenses.push(expense);
                        }
                    }
                }
            }
            this.expensesData = expenses;
            this.loading = false;
        },
        readFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => resolve(event.target.result);
                reader.onerror = (error) => reject(error);
                reader.readAsText(file);
            });
        },
        checkProvider(item) {            
            const normalizeNit = (value) => {
                if (value === null || value === undefined) {
                    return null;
                }

                return String(value).replaceAll("-", "").trim() || null;
            };

            const providerNit = normalizeNit(item?.nit || item?.ProviderLegalNIT || item?.providernit);
            const providers = Array.isArray(this.providers) ? this.providers : [];

            if (!providerNit) {
                return null;
            }

            const branchProvider = providers.find((el) => {
                const currentNit = normalizeNit(el?.ProviderLegalNIT || el?.providernit || el?.nit);
                return currentNit === providerNit && String(el?.ID_Branch) === String(this.id_branch);
            });

            if (branchProvider) {
                return branchProvider;
            }

            return providers.find((el) => {
                const currentNit = normalizeNit(el?.ProviderLegalNIT || el?.providernit || el?.nit);
                return currentNit === providerNit && Number(el?.IsGlobalBranch) === 1;
            }) || providers.find((el) => {
                const currentNit = normalizeNit(el?.ProviderLegalNIT || el?.providernit || el?.nit);
                return currentNit === providerNit;
            }) || null;
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            const newDate = new Date(`${month}/${day}/${year}`)
            return this.moment(newDate).format('DD/MM/YYYY');
        },
        async addProvider(data) {
            //console.log(data);
            const providerNIT = data.nit ? data.nit.toString().replaceAll("-","") : null;
            const providerNRC = data.nrc ? data.nrc.toString().replaceAll("-","") : null;

            const provider = {
                ID_Provider: null,
                ProviderName: data.nombre,
                ProviderLegalName: data.nombreComercial,
                ProviderPhone: data.telefono ? data.telefono.toString().replaceAll("-","") : null,
                ProviderEmail: data.correo || null,
                ProviderContactPhone: data.telefono ? data.telefono.toString().replaceAll("-","") : null,
                ProviderContactMobile: data.telefono ? data.telefono.toString().replaceAll("-","") : null,
                ProviderContactName: data.nombre || data.nombreComercial || null,
                ProviderContactEmail: data.correo || null,
                ProviderLegalAddress: data.direccion.complemento,
                ProviderLegalSector: data.codActividad,
                ProviderLegalTaxPayerSize: "",
                ProviderLegalEntity: "",
                ProviderLegalNRC: providerNRC,
                ProviderLegalNIT: providerNIT,
                Notes: 'Insertado autamaticamente por importación de gastos',
                ID_Business: this.id_bussiness,
                ID_Branch: this.id_branch,
                IsGlobalBranch: 1,
                ID_User_Insert: this.id_user,
                LegalAgentRetain: data.ivaPerci1 > 0 ? 1 : 0,            
            };
            
            return await this.$API.accountingexpenses.saveProvidersExpenses(provider)
                .then(async (response) => {
                    await this.getAllProviders();
                    return response.data;
                })
                .catch((error) => {
                    console.log(error)
                    throw new Error('Ha ocurrido un error al insertar los proveedores, intentelo de nuevo más tarde.');
                });
        },
        async checkDuplicatedEntries(value) {
            return await this.$API.accountingexpensesentry.verifyGenerationCodes({ codigosGeneracion: value })
                .then((response) => {
                    return response?.duplicates || [];
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        getAllAccounts() {
            this.$API.branchaccountcatalog.getAssignableAccounts()
                .then((response) => {
                    this.accountList = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handleChangeAccount(e, index) {
            const found = this.accountList.find((current) => current.id_account == e.target.value);        
            this.expensesData[ index ].id_account = found.id_account;
            this.expensesData[ index ].account_code = found.account_code;
            this.expensesData[ index ].account_name = found.account_description;
            this.data[ index ].id_account = found.id_account;
            this.data[ index ].account_code = found.account_code;
            this.data[ index ].account_name = found.account_description;
            this.handleBlurOnSelect();
        },
        handleBlurOnSelect() {
            this.isSelectShowed = false;
        },
        toggleSelect(index) {
            this.isSelectShowed = true;
            // Enfocar el select cuando se abre
            if (this.$nextTick) {
                this.$nextTick(() => {
                    const accountListSelect = `accountListSelect-${index}`;
                    if (this.$refs[accountListSelect]) {
                        this.$refs[accountListSelect].focus();
                    }
                });
            }
        },
        assignAllAccounts() {       
            const found = this.accountList.find((current) => current.id_account == this.account.id_account);        
            for (const item of this.expensesData) {
                if (found) {
                    /* item.id_account = found.id_account;
                    item.account_code = found.account_code;
                    item.account_name = found.account_description; */
                    this.$set(item, 'id_account', found.id_account);
                    this.$set(item, 'account_code', found.account_code);
                    this.$set(item, 'account_name', found.account_description);
                } 
            }
            for (const item of this.data) {
                if (found) {
                    item.id_account = found.id_account;
                    item.account_code = found.account_code;
                    item.account_name = found.account_description;
                    /* this.$set(item, 'id_account', found.id_account);
                    this.$set(item, 'account_code', found.account_code);
                    this.$set(item, 'account_name', found.account_description); */
                } 
            }
            this.$forceUpdate();            
            this.showAlert("success", "Exito", `Se ha actualizado la tabla asignando la cuenta seleccionada a los gastos importados.`);
        },
        assignAllClassifications() {
            let updated = false;
            
            for (const item of this.data) {
                if (this.globalTipoIngresoProveedores !== null && this.globalTipoIngresoProveedores !== undefined) {
                    item.TipoIngresoProveedores = this.globalTipoIngresoProveedores;
                    updated = true;
                }
                if (this.globalSectorProveedores !== null && this.globalSectorProveedores !== undefined) {
                    item.SectorProveedores = this.globalSectorProveedores;
                    updated = true;
                }
                if (this.globalClasificationRent !== null && this.globalClasificationRent !== undefined) {
                    item.ClasificationRent = this.globalClasificationRent;
                    updated = true;
                }
            }
            
            for (const item of this.expensesData) {
                if (this.globalTipoIngresoProveedores !== null && this.globalTipoIngresoProveedores !== undefined) {
                    item.TipoIngresoProveedores = this.globalTipoIngresoProveedores;
                }
                if (this.globalSectorProveedores !== null && this.globalSectorProveedores !== undefined) {
                    item.SectorProveedores = this.globalSectorProveedores;
                }
                if (this.globalClasificationRent !== null && this.globalClasificationRent !== undefined) {
                    item.ClasificationRent = this.globalClasificationRent;
                }
            }
            
            if (updated) {
                this.$forceUpdate();
                this.showAlert("success", "Éxito", `Se han actualizado los campos de clasificación para todos los gastos importados.`);
            }
        },
        async processData() {
            this.loading = true;
            this.nextStep();
            try {
                if(!this.expensesData.length || !this.data.length) throw new Error('No ha seleccionado archivo con la información.');
                                 
                for (const item of this.data) {
                    const formData = new FormData();
                    const expensesEntryDetail = [];

                    if(item.toEntry === true && !item.error?.providerError) {
                        const processedDocument = item.processedDocument
                            || this.dataFiles.find(file => file === item.dteJson || file.dteJson === item.dteJson)?.processedDocument;
                        
                        // Detectar si es la nueva versión
                        const isNewVersionDCL = this.isNewVersionJson(item.dteJson);
                        const isFEX = item.dteJson?.identificacion?.tipoDte === '11'
                            || item.invoiceType === 'FEX';
                        
                        let expensesEntry;
                        
                        if (isNewVersionDCL) {
                            // Nueva versión - usar datos de cuerpoDocumento ExpenseInvoiceType
                            // Extraer numeroDocumento de documentoRelacionado si existe
                            let numeroDocumentoRelacionado = null;
                            if (item.dteJson.documentoRelacionado && 
                                Array.isArray(item.dteJson.documentoRelacionado) && 
                                item.dteJson.documentoRelacionado.length > 0) {
                                numeroDocumentoRelacionado = item.dteJson.documentoRelacionado[0].numeroDocumento || null;
                            }
                            
                            expensesEntry = {
                                ID_Provider: item.provider,
                                SubTotal: item.dteJson.cuerpoDocumento.subTotal || 0,
                                TotalExpense: item.dteJson.cuerpoDocumento.liquidoApagar || 0,
                                ExpenseInvoiceDate: item.fecEmi,
                                ExpenseInvoiceType: item.invoiceType,
                                ExpenseInvoiceDocumentType: 2,
                                ExpenseInvoiceId: item.codigoGeneracion,
                                ExpenseInvoicePayment: null,
                                ExpenseInvoiceStatus: 'Pendiente de pago', // Valor por defecto para nueva versión
                                ExpenseInvoiceCreditDays: null,
                                ExpenseInvoiceComment: '',
                                Iva: item.dteJson.cuerpoDocumento.iva || 0,
                                Exentas: 0, // No esta en la version nueva creada para mantener el formato original
                                NoSujetas: 0, // No esta en la version nueva creada para mantener el formato original
                                ReteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                                IvaRet: 0, // No esta en la version nueva creada para mantener el formato original
                                IvaPerc: item.dteJson.cuerpoDocumento.ivaPercibido || 0,
                                Descuento: item.dteJson.resumen?.descuGravada || 0,
                                ID_AccountCatalog: item.id_account,
                                CatalogName: item.account_name,
                                Fovial: 0, // No esta en la version nueva creada para mantener el formato original
                                Cotrans: 0, // No esta en la version nueva creada para mantener el formato original
                                Flete: 0, // No esta en la version nueva creada para mantener el formato original
                                Seguro: 0, // No esta en la version nueva creada para mantener el formato original
                                DteJson: item.dteJson,
                                PercentageIVA: isFEX
                                    ? null
                                    : (this.percentageIvaCheck ? this.percentageIva : null),
                                isDuplicated: item.error?.isDuplicated ? true : false,
                                CustomCSVPeriodFlag: this.CustomCSVPeriodFlag,
                                CustomCSVPeriodYear: this.CustomCSVPeriodYear,
                                CustomCSVPeriodMonth: this.CustomCSVPeriodMonth,
                                ClasificationRent: this.ClasificationRent,
                                TipoIngresoProveedores: item.TipoIngresoProveedores || null,
                                SectorProveedores: item.SectorProveedores || null,
                                NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                                // Campos específicos DCL basados en el JSON
                                numeroControl: item.dteJson.identificacion.numeroControl || null,
                                periodoLiquidacionFechaInicio: item.dteJson.cuerpoDocumento.periodoLiquidacionFechaInicio || null,
                                periodoLiquidacionFechaFin: item.dteJson.cuerpoDocumento.periodoLiquidacionFechaFin || null,
                                valorOperaciones: item.dteJson.cuerpoDocumento.valorOperaciones || 0,
                                codLiquidacion: item.dteJson.cuerpoDocumento.codLiquidacion || null,
                                cantidadDoc: item.dteJson.cuerpoDocumento.cantidadDoc || 1,
                                montoSujetoPercepcion: item.dteJson.cuerpoDocumento.montoSujetoPercepcion || 0,
                                ivaPercibido: item.dteJson.cuerpoDocumento.ivaPercibido || 0,
                                comision: item.dteJson.cuerpoDocumento.comision || 0,
                                porcentComision: item.dteJson.cuerpoDocumento.porcentComision || 0,
                                ivaComision: item.dteJson.cuerpoDocumento.ivaComision || 0,
                                liquidoApagar: item.dteJson.cuerpoDocumento.liquidoApagar || 0,
                                montoSinPercepcion: item.dteJson.cuerpoDocumento.montoSinPercepcion || 0,
                                // Campos adicionales para compatibilidad
                                EmpleadoEntrega: item.dteJson.extension ? item.dteJson.extension.nombEntrega : null,
                                CodigoEmpleado: item.dteJson.extension ? item.dteJson.extension.codEmpleado : null,
                                selloRecibido: findSelloRecibido(item.dteJson),
                            };
                            
                            // Para la nueva versión, crear un solo detalle
                            const totalDCL = item.dteJson.cuerpoDocumento.liquidoApagar || 0;
                            const subTotalDCL = item.dteJson.cuerpoDocumento.subTotal || 0;
                            const ivaDCL = item.dteJson.cuerpoDocumento.iva || 0;
                            
                            const expensesDetails = {
                                ID: null,
                                ExpenseInvoiceId: item.codigoGeneracion,
                                NameExpense: `${item.dteJson.emisor.nombre}`,
                                UnitPrice: totalDCL,
                                Quantity: 1,
                                Total: totalDCL,
                                ID_AccountCatalog: item.id_account,
                                CatalogName: item.account_name,
                                ItemDeclarationType: item.ItemDeclarationType || 2,
                                IsNoSujeto: 0,
                                IsExento: 0,
                                IsHidrocarburo: 0,
                                // Cálculo de impuestos por item
                                NetoUnitario: parseFloat(subTotalDCL.toFixed(2)),
                                Iva: parseFloat(ivaDCL.toFixed(2)),
                                ReteRenta: 0,
                                Exentas: 0,
                                NoSujetas: 0,
                                Fovial: 0,
                                Cotrans: 0,
                                // Campos específicos de la nueva versión
                                Comision: item.dteJson.cuerpoDocumento.comision || 0,
                                IvaComision: item.dteJson.cuerpoDocumento.ivaComision || 0,
                                MontoSujetoPercepcion: item.dteJson.cuerpoDocumento.montoSujetoPercepcion || 0,
                                MontoSinPercepcion: item.dteJson.cuerpoDocumento.montoSinPercepcion || 0,
                            };

                            expensesEntryDetail.push(expensesDetails);
                            
                        } else {
                            // Versión original
                            const processingDetails = processedDocument?.details || item.dteJson.cuerpoDocumento;
                            const adjustedTotals = processedDocument?.totals;
                            // Extraer numeroDocumento de documentoRelacionado si existe
                            let numeroDocumentoRelacionado = null;
                            if (item.dteJson.documentoRelacionado && 
                                Array.isArray(item.dteJson.documentoRelacionado) && 
                                item.dteJson.documentoRelacionado.length > 0) {
                                numeroDocumentoRelacionado = item.dteJson.documentoRelacionado[0].numeroDocumento || null;
                            }
                            
                            expensesEntry = {
                                ID_Provider: item.provider,
                                SubTotal: adjustedTotals ? adjustedTotals.subTotal : item.subTotal,
                                TotalExpense: adjustedTotals ? adjustedTotals.totalPagar : item.totalPagar,
                                ExpenseInvoiceDate: item.fecEmi,
                                ExpenseInvoiceType: item.invoiceType,
                                ExpenseInvoiceDocumentType: 2,
                                ExpenseInvoiceId: item.codigoGeneracion,
                                ExpenseInvoiceNumeroControl: item.dteJson.identificacion.numeroControl || null,
                                ExpenseInvoicePayment: null,
                                ExpenseInvoiceStatus: (item?.dteJson?.resumen?.condicionOperacion == 2? 'Crédito' : 'Cancelada') || 'Cancelada',
                                ExpenseInvoiceCreditDays: null,
                                ExpenseInvoiceComment: '',
                                Iva: isFEX ? 0 : (adjustedTotals ? adjustedTotals.totalIva : item.dteJson.resumen?.totalIva || 0),
                                Exentas: isFEX
                                    ? (adjustedTotals?.totalGravada ?? item.dteJson.resumen?.totalGravada ?? 0)
                                    : (item.dteJson.resumen?.totalExenta || 0),
                                NoSujetas: item.dteJson.resumen?.totalNoSuj || 0,
                                ReteRenta: item.dteJson.resumen?.reteRenta || 0,
                                IvaRet: item.dteJson.resumen?.ivaRete1 || 0,
                                IvaPerc: item.dteJson.resumen?.ivaPerci1 || 0,
                                Descuento: item.dteJson.resumen?.descuGravada || 0,
                                ID_AccountCatalog: item.id_account,
                                CatalogName: item.account_name,
                                Fovial: item.fovial ? item.fovial : 0,
                                Cotrans: item.cotrans ? item.cotrans : 0,
                                Flete: item.flete ? item.flete : 0,
                                Seguro: item.seguro ? item.seguro : 0,
                                DteJson: processedDocument?.dteJson || item.dteJson,
                                PercentageIVA: isFEX
                                    ? null
                                    : (this.percentageIvaCheck ? this.percentageIva : null),
                                isDuplicated: item.error?.isDuplicated ? true : false,
                                CustomCSVPeriodFlag: this.CustomCSVPeriodFlag,
                                CustomCSVPeriodYear: this.CustomCSVPeriodYear,
                                CustomCSVPeriodMonth: this.CustomCSVPeriodMonth,
                                ClasificationRent: this.ClasificationRent,
                                TipoIngresoProveedores: item.TipoIngresoProveedores || null,
                                SectorProveedores: item.SectorProveedores || null,
                                NumeroDocumentoRelacionado: numeroDocumentoRelacionado,
                                selloRecibido: findSelloRecibido(item.dteJson)
                            };

                            // Procesar cada elemento del detalle con la distribución configurada
                            for (const el of processingDetails) {
                                // Inicializar campos de impuestos
                                let netoUnitario = 0;
                                let ivaItem = 0;
                                let reteRentaItem = 0;
                                let exentasItem = 0;
                                let nosujetasItem = 0;
                                let totalItem = 0;
                                let isExento = 0;
                                let isNoSujeto = 0;

                                // Las FEX se contabilizan como exentas aunque el JSON
                                // del Ministerio las marque dentro de ventaGravada.
                                if (isFEX) {
                                    totalItem = parseFloat(el.ventaGravada || 0);
                                    exentasItem = totalItem;
                                    netoUnitario = totalItem;
                                    isExento = 1;
                                }
                                // Calcular según el tipo de venta
                                else if(el.ventaNoSuj != 0 && el.ventaExenta == 0 && el.ventaGravada == 0) {
                                    // No Sujeto
                                    totalItem = el.ventaNoSuj;
                                    nosujetasItem = el.ventaNoSuj;
                                    netoUnitario = el.ventaNoSuj;
                                    isNoSujeto = 1;
                                }
                                else if(el.ventaNoSuj == 0 && el.ventaExenta != 0 && el.ventaGravada == 0) {
                                    // Exento
                                    totalItem = el.ventaExenta;
                                    exentasItem = el.ventaExenta;
                                    netoUnitario = el.ventaExenta;
                                    isExento = 1;
                                }
                                else {
                                    // Gravado
                                    totalItem = parseFloat(el.ventaGravada || 0);
                                    
                                    // Determinar si el tipo de factura incluye IVA en el precio
                                    if (item.invoiceType == 'CCF' || item.invoiceType == 'NC' || item.invoiceType == 'ND') {
                                        // CCF: El precio NO incluye IVA
                                        netoUnitario = parseFloat(totalItem);
                                        ivaItem = parseFloat((totalItem * 0.13).toFixed(2));
                                    } else {
                                        // FCF/FNS/FE: El precio SÍ incluye IVA
                                        netoUnitario = parseFloat((totalItem / 1.13).toFixed(2));
                                        ivaItem = parseFloat((totalItem - netoUnitario).toFixed(2));
                                    }
                                    
                                    // Calcular retención de renta si aplica
                                    // Nota: Necesitarías información adicional para determinar si es servicio
                                    // Por ahora, se puede dejar en 0 o agregar lógica adicional
                                    reteRentaItem = 0;
                                }

                                // Determinar si es hidrocarburo basándose en el array de tributos del item
                                // En el JSON de MH, el array tributos contiene códigos: ["20", "D1", "C8"]
                                // D1 = FOVIAL, C8 = COTRANS
                                let isHidrocarburo = 0;
                                let fovialItem = 0;
                                let cotransItem = 0;

                                if (el.tributos && Array.isArray(el.tributos)) {
                                    const hasFovial = el.tributos.includes('D1');
                                    const hasCotrans = el.tributos.includes('C8');
                                    
                                    if (hasFovial || hasCotrans) {
                                        isHidrocarburo = 1;
                                        // FOVIAL = $0.20 por galón, COTRANS = $0.10 por galón
                                        if (hasFovial) {
                                            fovialItem = parseFloat((el.cantidad * 0.20).toFixed(2));
                                        }
                                        if (hasCotrans) {
                                            cotransItem = parseFloat((el.cantidad * 0.10).toFixed(2));
                                        }
                                    }
                                }

                                const expensesDetails = {
                                    ID: null,
                                    ExpenseInvoiceId: item.codigoGeneracion,
                                    NameExpense: el.descripcion,
                                    UnitPrice: processedDocument?.totals
                                        ? parseFloat((Number(el.ventaNoSuj || el.ventaExenta || el.ventaGravada || 0) / (Number(el.cantidad) || 1)).toFixed(2))
                                        : el.precioUni,
                                    Quantity: el.cantidad,
                                    // Para FEX el importe se registra en Exentas.
                                    // Total debe quedar en cero porque la provisión
                                    // suma Total + Exentas + NoSujetas.
                                    Total: isFEX ? 0 : totalItem,
                                    ID_AccountCatalog: el.id_account ? el.id_account : item.id_account,
                                    CatalogName: el.account_name ? el.account_name : item.account_name,
                                    ItemDeclarationType: item.ItemDeclarationType,
                                    IsExento: isExento,
                                    IsNoSujeto: isNoSujeto,
                                    IsHidrocarburo: isHidrocarburo,
                                    // Impuestos calculados por item
                                    NetoUnitario: parseFloat(netoUnitario.toFixed(2)),
                                    Iva: parseFloat(ivaItem.toFixed(2)),
                                    ReteRenta: parseFloat(reteRentaItem.toFixed(2)),
                                    Exentas: parseFloat(exentasItem.toFixed(2)),
                                    NoSujetas: parseFloat(nosujetasItem.toFixed(2)),
                                    Fovial: fovialItem,
                                    Cotrans: cotransItem,
                                };

                                expensesEntryDetail.push(expensesDetails);
                            }
                        }                        
                        
                        formData.append("expensesEntry", JSON.stringify(expensesEntry));
                        formData.append("expensesEntryDetail", JSON.stringify(expensesEntryDetail));
                        
                        // Usar endpoint diferente según la versión del JSON
                        if (isNewVersionDCL) {
                            // Nuevo endpoint para DCL (Declaración de Comisiones por Liquidación)
                            await this.$API.accountingexpensesentry.ImportAccountingExpensesDCL(formData)
                                .then((res) => {
                                    if(res.success) {
                                        this.processed.push(item);
                                    }
                                })
                            .catch((error) => {
                                const backendMessage = this.getBackendErrorMessage(error);
                                item.error = {
                                    ...(item.error || {}),
                                    message: backendMessage,
                                    backendMessage,
                                };
                                this.notProcessed.push(item);
                                //this.processError = true;
                                console.log(error);
                                //throw new Error();
                                });
                        } else {
                            // Endpoint original para facturas tradicionales
                            await this.$API.accountingexpensesentry.ImportAccountingExpenses(formData)
                                .then((res) => {
                                    if(res.success) {
                                        this.processed.push(item);
                                    }
                                })
                            .catch((error) => {
                                const backendMessage = this.getBackendErrorMessage(error);
                                item.error = {
                                    ...(item.error || {}),
                                    message: backendMessage,
                                    backendMessage,
                                };
                                this.notProcessed.push(item);
                                //this.processError = true;
                                console.log(error);
                                //throw new Error();
                                });
                        }                
                    }
                    else {
                        this.notProcessed.push(item);
                    }
                }
                this.loading = false;
                if(this.data.length == this.processed.length) {
                    this.showAlert("success", "Gastos contables importados", "Los gastos importados fueron agragados correctamente.");
                }
                else if(this.data.length == this.notProcessed.length) {
                    this.showAlert("warning", "Gastos contables importados", "Los gastos importados no pudieron procesarse debido a la existencia de errores.");
                }
                else if(this.data.length != this.processed.length) {
                    this.showAlert("warning", "Gastos contables importados", "Algunos gastos importados no pudieron procesarse debido a la existencia de errores.");
                }
            } 
            catch (error) {
                this.loading = false;
                this.processError = true;
                this.showAlert("danger", "Error", this.getBackendErrorMessage(error));
            }
        },
        exportToExcel(value) {
            if(value === 'ERROR') {
                const headers = this.tableHeaders.map(header => header.text);
                const data = this.productsNotAllowed.map(item => this.tableHeaders.map(header => item[header.value]));
    
                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla inventario');
    
                XLSX.writeFile(workbook, 'plantilla_inventario_errores.xlsx');

            } else if(value === 'SUCCESS') {
                const headers = this.expensesHeaders.map(header => header.text);
                const data = this.processed.map(item => this.expensesHeaders.map(header => item[header.value]));
    
                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Gastos importados');
    
                XLSX.writeFile(workbook, 'Gastos_importados.xlsx');

            }
        },
        switchEntryData(item) {
            if(!item) return;
            
            // No permitir cambiar el estado SOLO si falta selloRecibido requerido
            if(item.error && item.error.selloRecibidoRequired) {
                return;
            }
            
            for (const element of this.dataFiles) {
                if(element.identificacion.numeroControl == item.numeroControl && element.identificacion.codigoGeneracion == item.codigoGeneracion) {
                    element.toEntry = !element.toEntry;
                }
            }
        },
        switchSelectAll() {
            for (const item of this.data) {
                // No cambiar el estado SOLO si falta selloRecibido requerido
                if(!item.error || !item.error.selloRecibidoRequired) {
                    item.toEntry = this.selectAll;
                }
            }
            for (const item of this.dataFiles) {
                // No cambiar el estado SOLO si falta selloRecibido requerido
                if(!item.error || !item.error.selloRecibidoRequired) {
                    item.toEntry = this.selectAll;
                }
            }
        },
        deleteFile(file) {
            console.log(file);
            this.data.filter((item) => item.numeroControl != file.numeroControl && item.codigoGeneracion != file.codigoGeneracion);
            this.dataFiles.filter((item) => item.identificacion.numeroControl != file.numeroControl && item.identificacion.codigoGeneracion != file.codigoGeneracion);
        },
        onClickProcess() {
            this.showAlert("question2", "Advertencia", "¿Esta seguro que desea continuar?", "processData");
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        closeAlert() {
            this.alert.show = false;
            if (this.alert.options == 'duplicateDocuments') {
                this.duplicateDocuments = [];
                this.loading = false;
            }
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
            this.alert.options = null;
        },
        acceptAlert() {
            this.alert.show = false;
            if (this.alert.options == 'duplicateDocuments') {
                this.continueWithAllDuplicates();
                this.alert.options = null;
                return;
            }
            if (this.alert.options == 'processData') {
                this.processData();
            }
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
            this.alert.options = null;
        },
        secondaryAlert() {
            this.alert.show = false;
            if (this.alert.options == 'duplicateDocuments') {
                this.continueWithoutDuplicates();
            }
            this.alert.options = null;
        },
        continueWithoutDuplicates() {
            const duplicatedCodes = new Set(
                (this.duplicateDocuments || [])
                    .map(item => this.normalizeGenerationCode(item?.codigoGeneracion))
                    .filter(Boolean)
            );

            this.dataFiles = this.dataFiles.filter(item => {
                const code = this.normalizeGenerationCode(item?.identificacion?.codigoGeneracion);
                return !duplicatedCodes.has(code);
            });

            this.duplicateDocuments = [];
            this.loading = false;

            if (this.dataFiles.length === 0) {
                this.showAlert(
                    "warning",
                    "Advertencia",
                    "No quedan documentos para procesar después de excluir los duplicados."
                );
                return;
            }

            this.handleFilesUpload();
        },
        continueWithAllDuplicates() {
            this.loading = false;
            this.handleFilesUpload();
        },
        showError(message) {
            this.showAlert("warning", "Advertencia", message);
        },
        getBackendErrorMessage(error) {
            return error?.response?.data?.message
                || error?.response?.data?.error
                || error?.message
                || "Ocurrio un error en el procesamiento de la información.";
        },
        resetData() {
            this.dataLoaded = false;
            this.selectAll = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.expensesData = [];
            this.errors = null;
            this.processError = false;
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
            this.globalTipoIngresoProveedores = null;
            this.globalSectorProveedores = null;
            this.globalClasificationRent = '2';
            this.duplicateDocuments = [];
            this.invalidJsonFiles = [];  // Limpiar archivos inválidos
            this.getAllProviders();
        },
        resetAll() {
            this.step = 1;
            this.loading = false;
            this.dataLoaded = false;
            this.selectAll = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.expensesData = [];
            this.errors = null;
            this.processError = false;
            this.processed = [];
            this.notProcessed = [];
            this.showNotProcessed = false;
            this.showProcessed = false;
            this.account = {
                id_account: null
            };
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
            this.globalTipoIngresoProveedores = null;
            this.globalSectorProveedores = null;
            this.globalClasificationRent = '2';
            this.duplicateDocuments = [];
            this.invalidJsonFiles = [];  // Limpiar archivos inválidos
            this.getAllProviders();
            this.cleanState = true;
        },
    }
};
</script>

<style scoped>
.card-step {
    min-height: 400px; 
    width: 100%; 
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2rem;
}
.col-input-file {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 1rem;
}
.btn-import {
  background-color: #3498db !important;
  color: white;
  min-width: 250px !important;
  height: 40px !important;
}
.btnoption {
  background-color: #3498DB !important;
  color: white;
}
.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}
.btndisable {
    background-color: #41464c !important;
    color: white;
}
</style>

<style>
.mdi-file-excel::before {
    font-size: 32px !important;
}
.data-table .v-data-table__wrapper thead th {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.data-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.data-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.file-table .v-data-table__wrapper thead th {
    height: 5px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td.text-start {
    padding: 0px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.tabs-seg .v-slide-group__content {
    justify-content: space-between;
}
.check .v-input__control {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
}

</style>
